<template>
  <div class="schedule-tables no-select">
    <!-- small screen -->
    <div
      v-if="isMobileDevice || $store.getters.isDigitalMode"
      :class="getRowClassObject"
      class="row collapse expanded small-up-1 schedule-tables"
    >
      <div
        v-if="
          getMobileTable.hasOwnProperty('periods') &&
          getMobileTable.hasOwnProperty('times') &&
          getMobileTable.hasOwnProperty('day')
        "
        class="column table-col"
      >
        <div class="row collapse schedule-table">
          <!-- info col -->
          <div class="small-3 columns info-col">
            <div class="schedule-header c1">
              <img :src="getCurrentClientLogo"/>
            </div>
            <div class="row collapse small-up-2 schedule-content">
              <div class="column schedule-period-price-col">
                <!-- periods -->
                <div class="schedule-sub-header">
                  <i class="money icon"></i>
                </div>
                <div
                  v-for="period in getMobileTable.periods"
                  :key="period.start_hour"
                  :style="getPeriodStyleObject(getMobileTable, period.interval)"
                  class="schedule-period-price"
                >
                  <div class="period-text-container">
                    <div class="period-text">{{ period.price }}</div>
                  </div>
                </div>
                <!-- ./periods -->
              </div>
              <!-- time -->
              <div class="column schedule-time-col">
                <div class="schedule-sub-header">
                  <i class="calendar icon"></i>
                </div>
                <div
                  v-for="time in getMobileTable.times"
                  :key="time.start_mins_of_day"
                  :style="getBlockStyleObject(getMobileTable, time)"
                  class="time-block"
                >
                  {{ time.caption ? time.caption : time }}
                </div>
              </div>
              <!-- ./times -->
            </div>
          </div>
          <!-- ./info col -->
          <!-- time col -->
          <div class="small-9 columns time-col">
            <!-- days col -->
            <div class="row collapse small-up-1">
              <!-- day col -->
              <div class="column day-col">
                <div class="schedule-header c2">
                  <button v-if="!$store.getters.isDigitalMode"
                          @click="decreaseCurrentDay">
                    <i class="arrow left icon"></i>
                  </button>
                  {{ getDayText(getMobileTable.day.name) }}
                  <button v-if="!$store.getters.isDigitalMode"
                          @click="increaseCurrentDay">
                    <i class="arrow right icon"></i>
                  </button>
                  <div>{{ getDayDateForHeader(getMobileTable.day.date) }}</div>
                </div>
                <!-- subjects -->
                <div
                  :class="getSubjectsColCountClass(getMobileTable)"
                  class="row collapse schedule-content"
                >
                  <!-- subject col -->
                  <div
                    v-for="(subject, subjectIndex) in getMobileTable.day.subjects"
                    :key="subject.ID"
                    class="column"
                  >
                    <div class="schedule-sub-header subject">
                      <div>{{ subject.name }}</div>
                    </div>
                    <div
                      v-for="(timeBlock, index) in subject.fill"
                      :key="index"
                      :class="
                        getTimeBlockClass(timeBlock, index, getMobileTable)
                      "
                      :style="getBlockStyleObject(getMobileTable)"
                      class="time-block"
                    >
                      <!-- ------------------- partner available overlay -------------- -->
                      <div
                        v-if="timeBlock.partnerAvailable || timeBlock.ownAvailable || timeBlock.partnerIncomings || timeBlock.partnerOutgoings"
                        :class="{
                                'pf-own-avail':timeBlock.ownAvailable,
                                'pf-partner-avail': timeBlock.partnerAvailable,
                                'pf-incoming': timeBlock.partnerIncomings,
                                'pf-outgoing': timeBlock.partnerOutgoings,
                                'pf-accepted-wo-reserve': timeBlock.acceptedWithoutReserve
                                }"></div>
                      <div
                        :class="timeBlock.status"
                        class="time-block-content-container"
                        @click="timeBlockClick(getMobileTable.tableIndex, index, subject, timeBlock)"
                      >
                        <div
                          v-if="timeBlock.status === 'free'"
                          class="
                            no-select
                            time-block-click-content time-block-icon-container
                          "
                        >
                          <!--@click="
                            openNewReservation(
                              timeBlock.startTime,
                              subject.ID,
                              subject.name,
                              subject.subjectTypeName,
                              false,
                              index,
                              getMobileTable.periods
                            )
                          "-->

                          f
                        </div>
                        <div
                          v-else-if="
                            timeBlock.status === 'own' ||
                            timeBlock.status === 'own-trainer' ||
                            timeBlock.partner
                          "
                          class="
                            no-select
                            time-block-click-content time-block-icon-container
                          "
                        ><img
                          v-if="IS_CORDOVA_APP"
                          src="static/img/own-reservation-icon.svg"
                        />
                          <img
                            v-else
                            src="/static/img/own-reservation-icon.svg"
                          />
                        </div>
                        <div
                          v-else-if="timeBlock.status === 'club'"
                          class="no-select time-block-icon-container"
                        >
                          <img
                            v-if="IS_CORDOVA_APP"
                            src="static/img/club-reservation-icon.svg"
                          />
                          <img
                            v-else
                            src="/static/img/club-reservation-icon.svg"
                          />
                        </div>
                        <div
                          v-else-if="timeBlock.status === 'closed'"
                          class="no-select"
                        ></div>
                        <div v-else
                             class="no-select time-block-icon-container">
                          <img
                            v-if="IS_CORDOVA_APP"
                            src="static/img/reserved-reservation-icon.svg"
                          />
                          <img
                            v-else
                            src="/static/img/reserved-reservation-icon.svg"
                          />
                        </div>
                        <a v-if="timeBlock.partner"
                           class="time-block-partner"
                        >
                          <i class="user icon"></i>
                        </a>
                      </div> <!-- time-block-content-container -->

                      <a v-if="timeBlockShowCancelNotif(timeBlock, subjectIndex)"
                         class="time-block-cancel-notif time-block-icon-container"
                         @click="timeBlockCancelNotifClick(timeBlock, subject)"
                      >
                        <i class="bell outline icon"></i>
                      </a>


                    </div>
                  </div>
                  <!-- ./subject col -->
                </div>
                <!-- ./subjects -->
              </div>
              <!-- ./day col -->
            </div>
          </div>
          <!-- ./time col -->
        </div>
      </div>
    </div>
    <!-- ./small screen -->
    <!-- medium and large screen -->
    <div
      v-else
      :class="getRowClassObject"
      class="row expanded small-collapse schedule-tables"
    >
      <!-- table has now and own tableIndex property created in mainView.processTableStatus() -->
      <!-- :class="getTableColClass(table, tables.length)" -->
      <div
        v-for="(table, tableIndex) in tables"
        :key="table.tableIndex"
        :style="{ flex : `0 0 ${getTableColPercent(table)}%`, maxWidth: `${getTableColPercent(table)}%`}"
        class="columns table-col"
      >
        <div class="schedule-table-container">
          <div class="row collapse schedule-table">
            <!-- info col -->
            <div class="small-3 columns info-col">
              <div class="schedule-header c3">
                <img :src="getCurrentClientLogo" />
              </div>
              <div class="row collapse schedule-content">
                <div class="small-4 columns schedule-period-price-col">
                  <!-- periods -->
                  <div class="schedule-sub-header">
                    <i class="money icon"></i>
                  </div>
                  <div
                    v-for="period in table.periods"
                    :key="'x' + period.start_hour"
                    :style="getPeriodStyleObject(table, period.interval)"
                    class="schedule-period-price"
                  >
                    <div class="period-text-container">
                      <div class="period-text">{{ period.price }}</div>
                    </div>
                  </div>
                  <!-- ./periods -->
                </div>
                <!-- time -->
                <div class="small-8 columns schedule-time-col">
                  <div class="schedule-sub-header">
                    <i class="calendar icon"></i>
                  </div>
                  <div
                    v-for="(time, index) in table.times"
                    :key="time.start_mins_of_day"
                    :class="{ 'period-last': isPeriodLast(index, table) }"
                    :style="getBlockStyleObject(table, time)"
                    class="time-block"
                  >
                    {{ time.caption ? time.caption : time }}
                  </div>
                </div>
                <!-- ./times -->
              </div>
            </div>
            <!-- ./info col -->
            <!-- time col -->
            <div class="small-9 columns time-col">
              <!-- days col -->
              <div :class="getDaysColCountClass(table)"
                   class="row collapse">
                <!-- day col -->
                <div v-for="day in table.days"
                     :key="day.date"
                     class="column day-col">
                  <div class="schedule-header c4">
                    <div>{{ getDayText(day.name) }}</div>
                    <div>{{ getDayDateForHeader(day.date) }}</div>
                  </div>
                  <!-- subjects -->
                  <div
                    :class="getSubjectsColCountClass(table)"
                    class="row collapse schedule-content"
                  >
                    <!-- subject col -->
                    <div v-for="(subject, subjectIndex) in day.subjects"
                         :key="subject.ID"
                         class="column">
                      <div class="schedule-sub-header subject">
                        <div>{{ subject.name }}</div>
                      </div>
                      <div
                        v-for="(timeBlock, index) in subject.fill"
                        :key="index"
                        :class="getTimeBlockClass(timeBlock, index, table)"
                        :data-client="timeBlock"
                        :style="getBlockStyleObject(table)"
                        class="time-block"
                        data-test="hyyy"
                      >
                        <!-- ------------------- partner available overlay -------------- -->
                        <div
                          v-if="timeBlock.partnerAvailable || timeBlock.ownAvailable || timeBlock.partnerIncomings || timeBlock.partnerOutgoings"
                          :class="{
                                'pf-own-avail':timeBlock.ownAvailable,
                                'pf-partner-avail': timeBlock.partnerAvailable,
                                'pf-incoming': timeBlock.partnerIncomings,
                                'pf-outgoing': timeBlock.partnerOutgoings,
                                'pf-accepted-wo-reserve': timeBlock.acceptedWithoutReserve
                                }"></div>

                        <div
                          :class="timeBlock.status"
                          class="time-block-content-container"
                          @click="timeBlockClick(tableIndex, index, subject, timeBlock)"
                        >
                          <div
                            v-if="timeBlock.status === 'free'"
                            class="
                              no-select
                              time-block-click-content time-block-icon-container
                            "
                          ><!--
                            @click="
                              openNewReservation(
                                timeBlock.startTime,
                                subject.ID,
                                subject.name,
                                subject.subjectTypeName,
                                tableIndex,
                                index
                              )
                            "-->
                            f
                          </div>
                          <div
                            v-else-if="
                              timeBlock.status === 'own' ||
                              timeBlock.status === 'own-trainer' ||
                              timeBlock.partner
                            "
                            class="
                              no-select
                              time-block-click-content time-block-icon-container
                            "
                          ><img
                            v-if="IS_CORDOVA_APP"
                            src="static/img/own-reservation-icon.svg"
                          />
                            <img
                              v-else
                              src="/static/img/own-reservation-icon.svg"
                            />
                          </div>
                          <div
                            v-else-if="timeBlock.status === 'club'"
                            class="no-select time-block-icon-container"
                          >
                            <img
                              v-if="IS_CORDOVA_APP"
                              src="static/img/club-reservation-icon.svg"
                            />
                            <img
                              v-else
                              src="/static/img/club-reservation-icon.svg"
                            />
                          </div>
                          <div
                            v-else-if="timeBlock.status === 'closed'"
                            class="no-select time-block-icon-container"
                          ></div>
                          <div
                            v-else
                            class="no-select time-block-icon-container"
                          >
                            <img
                              v-if="IS_CORDOVA_APP"
                              src="static/img/reserved-reservation-icon.svg"
                            />
                            <img
                              v-else
                              src="/static/img/reserved-reservation-icon.svg"
                            />
                          </div>
                          <a v-if="timeBlock.partner"
                             class="time-block-partner"
                          >
                            <i class="user icon"></i>
                          </a>
                        </div> <!-- time-block-content-container -->


                        <!-- ------------------- cancel-notification BELL -------------- -->
                        <a v-if="timeBlockShowCancelNotif(timeBlock, subjectIndex)"
                           class="time-block-cancel-notif time-block-icon-container"
                           @click="timeBlockCancelNotifClick(timeBlock, subject)"
                        >
                          <i class="bell outline icon"></i>
                        </a>


                      </div> <!-- time-block -->
                    </div> <!-- column -->
                    <!-- ./subject col -->
                  </div>
                  <!-- ./subjects -->
                </div>
                <!-- ./day col -->
              </div>
            </div>
            <!-- ./time col -->
          </div>
        </div>
      </div>
    </div>
    <!-- ./medium and large screen -->
    <!-- 'startTime', 'subjectId', 'subjectName', 'subjectTypeName' -->
    <new-reservation-modal
      :start-time="this.selectedReservationData.startTime"
      :subject-id="this.selectedReservationData.subjectID"
      :subject-name="this.selectedReservationData.subjectName"
      :subject-type-name="this.selectedReservationData.subjectTypeName"
      :ticket-price="this.selectedReservationData.ticketPrice"
      :time-block="this.selectedReservationData.timeBlock"
    />
    <own-reservation-modal
      :extra-options="selectedOwnReservationData.extraOptions"
      :reservation-code="selectedOwnReservationData.reservationCode"
      :start-time="selectedOwnReservationData.startTime"
      :subject-id="selectedOwnReservationData.subjectID"
      :subject-name="selectedOwnReservationData.subjectName"
      :subject-type-name="selectedOwnReservationData.subjectTypeName"
      :time-table-id="selectedOwnReservationData.timeTableID"
    />
    <other-reservation-modal/>
    <cancel-notification-modal/>
  </div>
</template>

<script>
import NewReservationModal from '../modal/NewReservationModal.vue';
import OwnReservationModal from '../modal/OwnReservationModal.vue';
import OtherReservationModal from '../modal/OtherReservationModal.vue';
import notify from '../../notify';
import config from '@/config';
import moment from 'moment';
import {MODAL as OTHER_RESERVATION_MODAL} from '../modal/OtherReservationModal';
import CancelNotificationModal, {
  MODAL as CANCEL_NOTIFICATION_MODAL,
} from '@/components/cancelNotification/CancelNotificationModal';
import utils from '../../utils';

export default {
  props: ['tables', 'isLoggedIn', 'tableDate', 'isMobileDevice'],
  data () {
    return {
      selectedReservationData: {
        timeBlock: null,
        startTime: null,
        subjectID: null,
        subjectName: null,
        subjectTypeName: null,
        ticketPrice: null,
      },
      selectedOwnReservationData: {
        startTime: null,
        subjectID: null,
        subjectName: null,
        subjectTypeName: null,
        timeTableID: null,
        extraOptions: null,
        reservationCode: null,
      },
      IS_CORDOVA_APP: config.IS_CORDOVA_APP,
    };
  },
  methods: {
    timeBlockShowCancelNotif (timeBlock, subjectIndex) {
      let cns = this.$store.state.cancelNotification.items;
      return (cns.indexOf(timeBlock.startTime) >= 0) && subjectIndex == 0;
    },
    increaseCurrentDay () {
      this.$store.dispatch('increaseCurrentDay');
      this.$emit('changeCurrentTableDate', this.$store.state.currentTableDate);
      this.$store.dispatch('fetchTable');//this.$parent.$emit("fetch-table");
    },
    decreaseCurrentDay () {
      this.$store.dispatch('decreaseCurrentDay');
      this.$emit('changeCurrentTableDate', this.$store.state.currentTableDate);
      //this.$parent.$emit("fetch-table");
      this.$store.dispatch('fetchTable');
    },
    timeBlockClick (tableIndex, index, subject, timeBlock) {
      console.log(timeBlock);
      if (timeBlock.status == 'free') {
        this.openNewReservation(
          timeBlock,
          timeBlock.startTime,
          subject.ID,
          subject.name,
          subject.subjectTypeName,
          tableIndex,
          index,
        );
      } else if (timeBlock.status == 'own' || timeBlock.status == 'own-trainer') {
        if (!this.$store.getters.isDigitalMode) {
          this.openOwnReservation(
            timeBlock.startTime,
            timeBlock.timeTableID,
            subject.ID,
            subject.name,
            subject.subjectTypeName,
            timeBlock.extraOptions,
            timeBlock.reservationCode,
          )
        }
      } else if (timeBlock.status == 'reserved') {
        if (!this.$store.getters.isDigitalMode) {
          if (!this.isLoggedIn) {
            notify.notRegistered('Kérjük jelentkezzen be vagy regisztráljon');
          } else {
            this.$modal.show(OTHER_RESERVATION_MODAL, {
              startTime: timeBlock.startTime,
              subjectId: subject.ID,
              subjectName: subject.name,
              subjectTypeName: subject.subjectTypeName,
            });
          }
        }
      }
    },
    timeBlockCancelNotifClick (timeBlock, subject) {
      this.$modal.show(CANCEL_NOTIFICATION_MODAL, { subject, from_time: timeBlock.startTime });
    },
    openOwnReservation (
      startTime,
      timeTableID,
      subjectID,
      subjectName,
      subjectTypeName,
      extraOptions,
      reservationCode,
    ) {
      this.selectedOwnReservationData.startTime = startTime;
      this.selectedOwnReservationData.subjectID = subjectID;
      this.selectedOwnReservationData.subjectName = subjectName;
      this.selectedOwnReservationData.timeTableID = timeTableID;
      this.selectedOwnReservationData.subjectTypeName = subjectTypeName;
      this.selectedOwnReservationData.extraOptions = extraOptions;
      this.selectedOwnReservationData.reservationCode = reservationCode;
      // eslint-disable-next-line
      this.$modal.show('own-reservation-modal');
    },
    openNewReservation (
      timeBlock,
      startTime,
      subjectID,
      subjectName,
      subjectTypeName,
      tableIndex,
      timeBlockIndex,
      mobilePeriods,
    ) {
      if (this.isLoggedIn) {
        this.selectedReservationData.timeBlock = timeBlock;
        // console.log('this.selectedReservationData.timeBlock', this.selectedReservationData.timeBlock);
        this.selectedReservationData.startTime = startTime;
        this.selectedReservationData.subjectID = subjectID;
        this.selectedReservationData.subjectName = subjectName;
        this.selectedReservationData.subjectTypeName = subjectTypeName;
        this.selectedReservationData.ticketPrice = false;

        let periods = null;
        if (!tableIndex && mobilePeriods) {
          periods = mobilePeriods;
        } else {
          periods = this.tables[tableIndex]?.periods;
        }

        if (periods) {
          let periodIntervalCounterHelper = 0;
          for (let period of periods) {
            periodIntervalCounterHelper += period.interval;
            if (timeBlockIndex < periodIntervalCounterHelper) {
              this.selectedReservationData.ticketPrice = period.price;
              break;
            }
          }
        }

        // eslint-disable-next-line
        this.$modal.show('new-reservation-modal');
      } else {
        notify.notRegistered('Kérjük a foglaláshoz jelentkezzen be vagy regisztráljon');
      }
    },
    getPeriodStyleObject (table, interval) {
      /*let blockCount = table.times.length;
      let height = (90 / blockCount) * Number(interval);
      let maxHeight = 1.7 * Number(interval);
      let styleObject = {
        height: "" + height + "%",
        "max-height": "" + maxHeight + "rem",
      };
      return styleObject;*/

      let ret = {
        height: '' + 23 * Number(interval) + 'px',
      };
      //console.log("/////////HEIGHT:", ret.height);
      return ret;
    },
    getBlockStyleObject (table, time) {
      /*let blockCount = table.times.length;
      let height = 90 / blockCount;
	  let ret =  {
        height: '' + height + '%'
      }
    if (time && time.no_border_bottom) {
      ret['border-bottom'] = '1px solid transparent';
    }

      return ret;
    */
      let ret = {
        height: '23px',
      };
      if (time && time.no_border_bottom) {
        ret['border-bottom'] = '1px solid transparent';
      }

      return ret;
    },
    getSubjectsColCountClass (table) {
      if (table?.days) {
        return 'medium-up-' + table.days[0].subjects.length;
      } else if (table?.day) {
        return 'small-up-' + table.day.subjects.length;
      } else {
        return 0;
      }
    },
    getDaysColCountClass (table) {
      return 'medium-up-' + table.days.length;
    },
    getDayText (day) {
      let daysTranslation = {
        Monday: 'Hétfő',
        Tuesday: 'Kedd',
        Wednesday: 'Szerda',
        Thursday: 'Csütörtök',
        Friday: 'Péntek',
        Saturday: 'Szombat',
        Sunday: 'Vasárnap',
      };
      // eslint-disable-next-line no-prototype-builtins
      if (daysTranslation.hasOwnProperty(day)) {
        return daysTranslation[day];
      }
      return day;
    },
    getDayDateForHeader (date) {
      if (moment(date).isValid()) {
        return moment(date).format('MM.DD.');
      }
      return null;
    },
    getTableColPercent (table) {
      const tableCount = this.tables.length;
      const subjectCount = this.tables[0]?.days[0]?.subjects?.length || 1;
      const infoCol = 1.5;
      return Math.floor((table.days.length * subjectCount + infoCol) / (7*subjectCount + tableCount*infoCol) * 100); 
    },
    getTableColClass (table, tableCount) {
      // eslint-disable-next-line no-prototype-builtins
      if (table.hasOwnProperty('days')) {
        let colCount = table.days.length;
        if (tableCount == 1 && colCount >= 5) {
          return 'medium-12';
        } else if (tableCount <= 2) {
          if (colCount >= 7) {
            return 'medium-12';
          } else if (colCount === 6) {
            return 'medium-9';
          } else if (colCount === 5) {
            return 'medium-8';
          } else if (colCount === 4) {
            return 'medium-7';
          } else if (colCount === 3) {
            return 'medium-5';
          } else if (colCount === 2) {
            return 'medium-4';
          } else if (colCount <= 1) {
            return 'medium-3';
          }
        } else {
          if (colCount >= 7) {
            return 'medium-12';
          } else if (colCount === 6) {
            return 'medium-9';
          } else if (colCount === 5) {
            return 'medium-6';
          } else if (colCount === 4) {
            return 'medium-6';
          } else if (colCount === 3) {
            return 'medium-5';
          } else if (colCount === 2) {
            return 'medium-4';
          } else if (colCount <= 1) {
            return 'medium-3';
          }
        }
      } else {
        return 'medium-12';
      }
    },
    getTimeBlockClass (timeBlock, index, table) {
      let result = {};
      // result[timeBlock.status] = true
      result['period-last'] = this.isPeriodLast(index, table);
      return result;
    },
    isPeriodLast (index, table) {
      const periods = table.periods;
      let isPeriodLast = false;
      let lastIndex = 0;
      for (let i in periods) {
        let period = periods[i];
        lastIndex += period.interval;
        if (lastIndex === index + 1) {
          isPeriodLast = true;
          break;
        }
      }
      return isPeriodLast;
    },
  },
  computed: {
    getRowClassObject () {
      /*
      let rowClassObject = {}
      if (this.tables.length >= 2) {
        rowClassObject['large-up-2'] = true
      } else {
        rowClassObject['large-up-1'] = true
      }
      return rowClassObject
      */
      return '';
    },
    getMobileTable () {
      let mobileTable = {};
      let tableDate = this.tableDate;
      let tables = this.tables;
      if (tableDate && tables) {
        for (let tableIndex in tables) {
          let table = tables[tableIndex];
          // eslint-disable-next-line no-prototype-builtins
          if (
            table.hasOwnProperty('days') &&
            table.hasOwnProperty('periods') &&
            table.hasOwnProperty('times')
          ) {
            for (let day of table.days) {
              if (day.date === tableDate) {
                mobileTable.tableIndex = tableIndex;
                mobileTable.periods = table.periods;
                mobileTable.times = table.times;
                mobileTable.day = day;
                break;
              }
            }
          }
        }
      }
      return mobileTable;
    },
    getCurrentClientLogo () {
      let logoUrl = '';
      let currentClientDomain = this.$store.state.currentClientDomain;
      if (currentClientDomain) {
        for (let client of this.$store.state.clients) {
          if (client.domain === currentClientDomain) {
            logoUrl = client.logo;
          }
        }
      }
      return logoUrl;
    },
  },
  mounted: function () {
    let cfg = this.$store.getters.getClientConfig(this.$store.state.currentClientDomain);
    if (cfg.customPopup && !this.$store.getters.isDigitalMode) {
      let key = cfg.customPopup.cookieKey;
      let cookie = utils.getCookie(key);
      if (!cookie) {
        notify.warning(cfg.customPopup.text);
        utils.setCookie(key, 1, 300, true);
      }
    }
  },
  components: {
    NewReservationModal,
    OwnReservationModal,
    OtherReservationModal,
    CancelNotificationModal,
  },
};
</script>

<style scoped>
.schedule-tables {
  /*height: 100%;*/
  text-align: center;
  /*
    border: 1px solid rgba(34,36,38,.15);
    border-radius: .28571429rem;
    */
}

.table-col {
  /*height: 100%;*/
}

.schedule-table {
  /*height: 100%;*/
  border: 2px solid #5a5a5a;
}

.info-col {
  /*height: 100%;*/
  border-right: 2px solid #5a5a5a;
  flex: 0 0 5.2em;
  max-width: none;
  
  /*
    border-left: 1px solid rgba(34,36,38,.15);
    border-right: 1px solid rgba(34,36,38,.15);
    */
}

.time-col {
  /*height: 100%;*/
  flex: 1;
  max-width: none;
}

.time-col > .row {
  /*height: 100%;*/
}

.time-col > .row > .column {
  /*height: 100%;*/
}

.schedule-header {
  text-transform: uppercase;
  height: 3.7rem;
  /*height: 10%;
    padding-top: 0.5rem;*/
  padding: 0.5rem 0 0.5rem 0;
  font-weight: normal;
  border-bottom: 1px solid #898989;
  border-top: 1px solid #898989;
  background: #fefefe;
  /*color: rgba(0,0,0,.87);*/
  color: #898989;
}

.schedule-header > button {
  cursor: pointer;
}

.schedule-content {
  height: 90%;
}

.schedule-content > .columns ~ .columns {
  /*
    border-left: 1px solid rgba(34,36,38,.15)
    */
}

/*
  .schedule-content > .column ~ .column {
    border-left: 1px solid rgba(34,36,38,.15)
  }
  */

.schedule-content > .column .time-block {
  border-left: 1px solid #898989;
}

.schedule-content > .column {
  /*height: 100%;*/
}

.schedule-period-price-col {
  /*height: 100%;*/
  flex: 0 0 1.8em;
  max-width: 1.8em;
}

.schedule-period-price {
  border-bottom: 2px solid #5a5a5a;
  border-right: 1px solid #898989;
  padding: 1px;
  overflow: hidden;
  /*border-left: 1px solid #898989;*/
}

.schedule-time-col {
  flex: 1;
  max-width: none;
}

.schedule-sub-header {
  /*height: 10%;
    padding-top: 0.5rem;*/
  /*padding: 0.5rem 0 0.5rem 0;*/
  font-weight: 600;
  /*border-bottom: 1px solid rgba(34,36,38,.15);*/
  border-bottom: 2px solid #5a5a5a;
  color: rgba(0, 0, 0, 0.87);
  background: #fefefe;
  padding: 1px;
}

.day-col:not(:last-child) {
  border-right: 2px solid #5a5a5a;
}

.period-text-container {
  width: 100%;
  height: 100%;
  background: #f17c1c;
  display: flex;
  justify-content: center;
}

.schedule-period-price:nth-child(odd) > .period-text-container {
  background: #f3a55d;
}

.period-text {
  /* -webkit-transform: rotate(90deg); */
  /* transform: rotate(90deg); */
  white-space: nowrap;
  /* padding-left: 50%; */
  /* padding-top: 50%; */
  /* margin-top: auto; */
  /* margin-bottom: auto; */
  margin: auto;
  /*padding: 0.2rem 0;*/
  writing-mode: vertical-rl;
  /*height: 100%;*/
  /*line-height: 100%;*/
  font-weight: bold;
  color: white;
  overflow: hidden;
}

.time-block {
  border-bottom: 1px solid #898989;
  color: #0a0a0a;
  max-height: 1.7rem;
  padding: 1px;
  position: relative;
}

.period-last {
  border-bottom: 2px solid #5a5a5a;
}

.time-block ~ .time-block {
  /*
    background: red;
    */
}

.free {
  cursor: pointer;
  color: rgba(255, 0, 0, 0);
}

.reserved {
  /* background: #f2711c; */
  background: #e5bdbd;
  color: rgba(255, 0, 0, 0);
  cursor: pointer; /* not-allowed; */
}

.past {
  /* background: #f2711c; */
  cursor: pointer;
  color: rgba(255, 0, 0, 0);
}

.past-reserved {
  /* background: #f2711c; */
  background: #a1b0cb;
  color: rgba(255, 0, 0, 0);
  cursor: not-allowed;
}

.own {
  background: #a1cba5;
  color: rgba(255, 0, 0, 0);
  cursor: pointer;
}

.own-trainer {
  background: #a1b0cb;
  color: rgba(255, 0, 0, 0);
  cursor: pointer;
}

.club {
  background: #e3c6a4;
  color: rgba(255, 0, 0, 0);
  cursor: not-allowed;
}

.closed {
  background: repeating-linear-gradient(
    45deg,
    #fff,
    #fff 10px,
    #d9d9d9 0,
    #d9d9d9 20px
  );
  color: rgba(255, 0, 0, 0);
  cursor: not-allowed;
}

.no-select {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.time-block-click-content {
  width: 100%;
  /*height: 100%;*/
}

.info-col .time-block {
  /*border-left: 1px solid #898989;*/
  /*
    border-right: 1px solid rgba(34,36,38,.15);
    */
}

.info-col > .schedule-header,
.schedule-period-price-col > .schedule-sub-header {
  border-left: 1px solid #898989;
  /*border-right: 1px solid #898989;*/
}

.time-col .schedule-header,
.schedule-time-col .schedule-sub-header,
.schedule-content .schedule-sub-header,
.time-col
> .row
> .column:last-child
> .schedule-content
> .column:last-child
.time-block {
  /*border-right: 1px solid #898989;*/
  white-space: nowrap;
}

.schedule-sub-header > i {
  color: #898989;
}

.schedule-sub-header.subject {
  color: #fff;
}

.schedule-sub-header.subject > div {
  background: #898989;
}

.info-col > .schedule-header {
  padding: 0;
}

.info-col > .schedule-header > img {
  height: auto;
  max-height: 100%;
}

.schedule-table-container {
  /*height: 100%;*/
  border: 3px solid #c2c2c2;
}

.time-block-content-container {
  width: 100%;
  height: 100%;
}

.time-block > div > div > img {
  padding: 1px;
  max-height: 100%;
}

.time-block-icon-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

a.time-block-cancel-notif {
  /*color:#8a6666;*/
  display: block;
  color: #000000;
  background: #ef9e58;
  position: absolute;
  height: 90%;
  width: 80%;
  left: -2px;
  top: 0px;
  cursor: pointer;
}

a.time-block-cancel-notif:hover {
  border: 1px solid #5a5a5a;
}

.pf-own-avail {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  /*background: #d9efdb;*/
  background: #c8dfef;
  z-index: -1;
}


.pf-partner-avail {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  /*background: #e8eaea;*/
  background: #92c47a7a;
  z-index: -1;
}

.pf-partner-avail.pf-own-avail {
  /*background: repeating-linear-gradient(45deg, #e8eaea 0,#e8eaea 10px, #c8dcca 0,#c8dcca 20px);*/
  background: #c8dfef;
  background: repeating-linear-gradient(45deg, #92c47a7a 0, #92c47a7a 10px, #c8dfef 0, #c8dfef 20px);
}

.pf-incoming {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: #a9fb76c2 !important;
  z-index: -1;
}

.pf-outgoing {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: #ffb733c2 !important;
  z-index: -1;
}

.pf-incoming.pf-outgoing {
  background: repeating-linear-gradient(45deg, #a9fb76c2 0, #a9fb76c2 10px, #ffb733c2 0, #ffb733c2 20px) !important;

}

.pf-accepted-wo-reserve {
  background: #ff5e00e3 !important;
}

.time-block-partner {
  display: block;
  /*color: #f14300;*/
  color: #cc5500;
  position: absolute;
  right: -5px;
  bottom: -4px;
  cursor: pointer;
}

</style>
